export default __webpack_public_path__ + "static/media/amico.7bbf9701.png";